// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"e9f57e","sponsorsInner":"_6e93fd","sponsorsItem":"_4151b5"};